import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { countries, devConfig, profile } from 'config/config'; // Importing configuration data

/**
 * Class representing a view for filtering and restricting users.
 * @extends JetView
 */
export default class FilterRestrictUserView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service

        /**
         * Converts a file to a Base64 string.
         * @param {File} file - The file to convert.
         * @returns {Promise<string>} A promise that resolves with the Base64 string.
         */
        function getBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader(); // FileReader instance
                reader.readAsDataURL(file); // Read file as data URL
                reader.onload = () => resolve(reader.result); // Resolve with result
                reader.onerror = (error) => reject(error); // Reject on error
            });
        }

        // Configuration for the first row of input fields
        const row = {
            margin: 10,
            id: 'r1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row', // CSS class for styling
                    responsive: 'r1', // Responsive design identifier
                    cols: [
                        {
                            view: 'text', // Text input for ID
                            name: 'Id',
                            minWidth: 200,
                            label: "<span class='icon-id'></span>" + _('Id'), // Label with icon
                            labelPosition: 'top',
                            placeholder: _('Id'), // Placeholder text
                        },
                        {
                            view: 'text', // Text input for Email
                            name: 'Email',
                            minWidth: 200,
                            label: _('Email'),
                            labelPosition: 'top',
                            placeholder: _('Email'),
                        },
                        {
                            view: 'text', // Text input for Document
                            name: 'Document',
                            minWidth: 200,
                            label: _('Documento'),
                            labelPosition: 'top',
                            placeholder: _('Documento'),
                        },
                        {
                            view: 'combo', // Dropdown for Document Type
                            name: 'DocType',
                            minWidth: 200,
                            label: _('Tipo de documento'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: '1', value: _('Cédula de ciudadania') },
                                { id: '2', value: _('Pasaporte') },
                                { id: '3', value: _('Cédula extranjería') },
                            ],
                        },
                    ],
                },
            ],
        };

        // Configuration for the second row of input fields
        const row2 = {
            margin: 10,
            id: 'r2',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'r2',
                    cols: [
                        {
                            view: 'text', // Text input for Name
                            name: 'Name',
                            minWidth: 200,
                            label: _('Nombre'),
                            labelPosition: 'top',
                            placeholder: _('Nombre'),
                        },
                        {
                            view: 'text', // Text input for Phone
                            name: 'Phone',
                            minWidth: 200,
                            label: _('Teléfono'),
                            labelPosition: 'top',
                            placeholder: _('Teléfono'),
                        },
                        {
                            view: 'richselect', // Rich select for Partner
                            name: 'Partner',
                            minWidth: 200,
                            label: _('Partner'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: profile.Partners, // Options from profile
                            value: profile.PartnerSelected, // Default selected value
                            readonly: true, // Read-only field
                        },
                        {
                            view: 'richselect', // Rich select for Country
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            minWidth: 200,
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value; // Template for displaying country flags
                                    },
                                    data: countries, // Country data
                                },
                            },
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility
                            css: 'prm-filterByCountry', // CSS class for styling
                        },
                        {
                            view: 'richselect', // Second rich select for Country
                            name: 'CountrySelect2',
                            minWidth: 200,
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: profile.Settings.ReportCountry, // Default selected value
                            readonly: true, // Read-only field
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value; // Template for displaying country flags
                                    },
                                    data: countries, // Country data
                                },
                            },
                            hidden: !devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility
                            css: 'prm-filterByCountry', // CSS class for styling
                        },
                    ],
                },
            ],
        };

        // Configuration for the third row of input fields
        const row3 = {
            margin: 10,
            id: 'r3',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'r3',
                    cols: [
                        {
                            view: 'combo', // Dropdown for Restriction Type
                            name: 'Type',
                            id: 'TypeFilter',
                            minWidth: 200,
                            label: _('Tipo de restricción'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [], // Options to be populated dynamically
                            on: {
                                onFocus: function () {
                                    // Event handler for focus
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json',
                                        })
                                        .post(devConfig.geturlApi() + 'Select/GetRestrictTypes', '', {
                                            error: function () {
                                                webix.message('Error! '); // Error message
                                            },
                                            success: function (text) {
                                                var resp = JSON.parse(text); // Parse response
                                                var list = $$('TypeFilter').getPopup().getList(); // Get dropdown list
                                                list.clearAll(); // Clear existing options
                                                list.parse(resp.Data); // Populate with new options
                                            },
                                        });
                                },
                            },
                        },
                        {
                            view: 'richselect', // Rich select for State
                            name: 'State',
                            minWidth: 200,
                            label: _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: '-1', value: _('Todas') },
                                { id: '0', value: _('Activa') },
                                { id: '1', value: _('Eliminada') },
                            ],
                        },
                        { gravity: 2, minWidth: 200 }, // Spacer
                    ],
                },
            ],
        };

        // Upper section containing the input rows
        const upper_section = {
            css: 'father-container', // CSS class for styling
            margin: 10,
            rows: [row, row2, row3], // Rows defined above
        };

        // Configuration for action buttons
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 1 }, // Spacer
                        {
                            view: 'button', // Button to load CSV
                            value: _('Cargar CSV'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 200,
                            minWidth: 200,
                            click: () => {
                                webix
                                    .ajax()
                                    .headers({
                                        'Content-type': 'application/json',
                                    })
                                    .post(devConfig.geturlApi() + 'Select/GetRestrictTypes', '', {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message('Error! '); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var resp = JSON.parse(text); // Parse response
                                            var base64CSV = ''; // Variable to hold Base64 CSV
                                            webix
                                                .ui({
                                                    view: 'window', // Window for CSV upload
                                                    width: 450,
                                                    fullscreen: screen == 'small' ? true : false,
                                                    head: {
                                                        view: 'toolbar',
                                                        cols: [
                                                            {
                                                                view: 'label',
                                                                label: _('Restricción Masiva'), // Window title
                                                            },
                                                            {
                                                                view: 'icon',
                                                                icon: 'wxi-close',
                                                                click: function () {
                                                                    this.getTopParentView().hide(); // Close window
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    position: 'center',
                                                    modal: true, // Modal window
                                                    body: {
                                                        view: 'form',
                                                        id: 'addform2', // Form ID
                                                        elements: [
                                                            {
                                                                margin: 10,
                                                                rows: [
                                                                    {
                                                                        view: 'richselect', // Rich select for Partner
                                                                        labelPosition: 'top',
                                                                        label: _('Partner'),
                                                                        name: 'Partner',
                                                                        options: profile.Partners, // Options from profile
                                                                        required: true, // Required field
                                                                        value: profile.PartnerSelected, // Default selected value
                                                                        readonly: true, // Read-only field
                                                                    },
                                                                    {
                                                                        view: 'richselect', // Rich select for Country
                                                                        labelPosition: 'top',
                                                                        label: _('País'),
                                                                        name: 'Country',
                                                                        value: !devConfig.getCountryReport()
                                                                            ? '0'
                                                                            : profile.Settings.ReportCountry, // Default selected value
                                                                        readonly: !devConfig.getCountryReport()
                                                                            ? false
                                                                            : true, // Conditional read-only
                                                                        options: {
                                                                            body: {
                                                                                template: function (obj) {
                                                                                    return (
                                                                                        "<i class='flags " +
                                                                                        obj.icon +
                                                                                        "'></i>" +
                                                                                        obj.value
                                                                                    ); // Template for displaying country flags
                                                                                },
                                                                                data: countries, // Country data
                                                                            },
                                                                        },
                                                                        required: true, // Required field
                                                                    },
                                                                    {
                                                                        view: 'combo', // Dropdown for Type
                                                                        labelPosition: 'top',
                                                                        label: _('Tipo'),
                                                                        required: true, // Required field
                                                                        name: 'Type',
                                                                        options: resp.Data, // Options from response
                                                                    },
                                                                    {
                                                                        view: 'uploader', // Uploader for CSV file
                                                                        id: 'uploader',
                                                                        value: _('Cargar archivo CSV'),
                                                                        on: {
                                                                            onBeforeFileAdd: function (upload) {
                                                                                // Event before file is added
                                                                                getBase64(upload.file).then((data) => {
                                                                                    base64CSV = data; // Store Base64 CSV
                                                                                });
                                                                                $$('uploader').define(
                                                                                    'label',
                                                                                    upload.name,
                                                                                ); // Update label
                                                                                $$('uploader').refresh(); // Refresh uploader
                                                                                var reader = new FileReader(); // FileReader instance
                                                                                reader.onload = function (event) {
                                                                                    var records =
                                                                                        event.target.result.split('\n'); // Split file into records
                                                                                    for (
                                                                                        var i = 0;
                                                                                        i < records.length;
                                                                                        i++
                                                                                    ) {
                                                                                        var record = {}; // Record object
                                                                                        records[i] =
                                                                                            records[i].split(';'); // Split record by semicolon
                                                                                        for (
                                                                                            var r = 0;
                                                                                            r < records[i].length;
                                                                                            r++
                                                                                        ) {
                                                                                            record['field' + (r + 1)] =
                                                                                                records[i][r]; // Map fields
                                                                                        }
                                                                                        records[i] = record; // Update record
                                                                                    }
                                                                                    $$('dt1').clearAll(); // Clear existing data
                                                                                    records = records.filter((item) => {
                                                                                        return item.field1 != ''; // Filter out empty records
                                                                                    });
                                                                                    $$('dt1').parse(records); // Parse new records into datatable
                                                                                    $$('dt1').show(); // Show datatable
                                                                                };
                                                                                reader.readAsText(upload.file); // Read file as text
                                                                                return false; // Prevent default behavior
                                                                            },
                                                                        },
                                                                    },
                                                                    {
                                                                        view: 'button', // Button to download example file
                                                                        value: _('Descargar Archivo Ejemplo'),
                                                                        click: function () {
                                                                            /**
                                                                             * Downloads a file from a given URI.
                                                                             * @param {string} uri - The URI of the file to download.
                                                                             * @param {string} name - The name to save the file as.
                                                                             */
                                                                            function downloadURI(uri, name) {
                                                                                var link = document.createElement('a'); // Create link element
                                                                                link.download = name; // Set download attribute
                                                                                link.href = uri; // Set href to URI
                                                                                document.body.appendChild(link); // Append link to body
                                                                                link.click(); // Trigger download
                                                                                document.body.removeChild(link); // Remove link from body
                                                                            }
                                                                            downloadURI(
                                                                                'https://images.virtualsoft.tech/site/csv_example.csv',
                                                                                'csv_example.csv',
                                                                            ); // Download example CSV
                                                                        },
                                                                    },
                                                                    {
                                                                        view: 'datatable', // Datatable for displaying uploaded records
                                                                        id: 'dt1',
                                                                        css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                                                                        hidden: true, // Initially hidden
                                                                        scrollY: true, // Enable vertical scrolling
                                                                        scrollX: true, // Enable horizontal scrolling
                                                                        height: screen == 'small' ? 0 : 200, // Conditional height
                                                                        columns: [
                                                                            {
                                                                                id: 'field1',
                                                                                width: 220,
                                                                                header: _('Email'), // Column header
                                                                            },
                                                                            {
                                                                                id: 'field2',
                                                                                header: _('Tipo Documento'), // Column header
                                                                                options: [
                                                                                    {
                                                                                        id: '1',
                                                                                        value: _(
                                                                                            'Cédula de ciudadania',
                                                                                        ),
                                                                                    },
                                                                                    {
                                                                                        id: '2',
                                                                                        value: _('Pasaporte'),
                                                                                    },
                                                                                    {
                                                                                        id: '3',
                                                                                        value: _('Cédula extranjería'),
                                                                                    },
                                                                                ],
                                                                                width: 220,
                                                                            },
                                                                            {
                                                                                id: 'field3',
                                                                                width: 220,
                                                                                header: _('Documento'), // Column header
                                                                            },
                                                                            {
                                                                                id: 'field4',
                                                                                width: 220,
                                                                                header: _('Nombre'), // Column header
                                                                            },
                                                                            {
                                                                                id: 'field5',
                                                                                width: 220,
                                                                                header: _('Teléfono'), // Column header
                                                                            },
                                                                        ],
                                                                    },
                                                                ],
                                                            },
                                                            {
                                                                cols: [
                                                                    {
                                                                        view: 'button', // Button to cancel the operation
                                                                        value: _('Cancelar'),
                                                                        click: function () {
                                                                            this.getTopParentView().hide(); // Close window
                                                                            $$('addform2').setValues(
                                                                                $$('addform2').getCleanValues(),
                                                                            ); // Reset form values
                                                                            $$('uploader').define(
                                                                                'label',
                                                                                _('Cargar archivo CSV'),
                                                                            ); // Reset uploader label
                                                                            $$('uploader').refresh(); // Refresh uploader
                                                                            base64CSV = ''; // Clear Base64 CSV
                                                                        },
                                                                    },
                                                                    {
                                                                        view: 'button', // Button to save the data
                                                                        type: 'form',
                                                                        value: _('Guardar'),
                                                                        click: function ($e) {
                                                                            var values = $$('addform2').getValues(); // Get form values
                                                                            if (
                                                                                $$('addform2').validate() &&
                                                                                base64CSV != ''
                                                                            ) {
                                                                                // Validate form and check if CSV is loaded
                                                                                webix
                                                                                    .ajax()
                                                                                    .headers({
                                                                                        'Content-type':
                                                                                            'application/json',
                                                                                    })
                                                                                    .post(
                                                                                        devConfig.geturlApi() +
                                                                                            'AdminUser/RestrictUser',
                                                                                        '{"CSV":"' +
                                                                                            base64CSV +
                                                                                            '", "Type":"' +
                                                                                            values.Type +
                                                                                            '", "Partner":"' +
                                                                                            values.Partner +
                                                                                            '", "Country":"' +
                                                                                            values.Country +
                                                                                            '", "Action":"1"}',
                                                                                        {
                                                                                            error: function (
                                                                                                text,
                                                                                                data,
                                                                                                XmlHttpRequest,
                                                                                            ) {
                                                                                                webix.message(
                                                                                                    'Error! ',
                                                                                                ); // Error message
                                                                                            },
                                                                                            success: function (
                                                                                                text,
                                                                                                data,
                                                                                                XmlHttpRequest,
                                                                                            ) {
                                                                                                text = JSON.parse(text); // Parse response
                                                                                                if (text.HasError) {
                                                                                                    webix.message(
                                                                                                        'Error: ' +
                                                                                                            text.AlertMessage,
                                                                                                    ); // Show error message
                                                                                                } else {
                                                                                                    webix.message(
                                                                                                        _(
                                                                                                            'Restricciónes creadas correctamente',
                                                                                                        ),
                                                                                                    ); // Success message
                                                                                                }
                                                                                            },
                                                                                        },
                                                                                    );
                                                                                this.getTopParentView().hide(); // Close window
                                                                            } else {
                                                                                webix.message({
                                                                                    title: _('¡Error!'),
                                                                                    type: 'alert-error',
                                                                                    text: _('Completa los campos...'), // Error message
                                                                                });
                                                                            }
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        ],
                                                        elementsConfig: {
                                                            on: {
                                                                onChange: function () {
                                                                    this.validate(); // Validate form on change
                                                                },
                                                            },
                                                        },
                                                    },
                                                })
                                                .show(); // Show the window
                                            $$('addform2').clearValidation(); // Clear validation
                                            $$('Type').define('options', resp.Data); // Update options for Type
                                            $$('Type').refresh(); // Refresh dropdown
                                        },
                                    });
                            },
                        },
                        {
                            minWidth: 200,
                            view: 'button', // Button to create restriction
                            value: _('Crear Restricción'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 150,
                            click: () => {
                                this.app.callEvent('create:button', [[]]); // Trigger create event
                            },
                        },
                        {
                            view: 'button', // Button to clear form
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear form fields
                            },
                        },
                        {
                            view: 'button', // Button to consult/filter data
                            value: _('Consultar'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get filter values
                                if (devConfig.getCountryReport()) {
                                    filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country filter if applicable
                                }
                                delete filterdata['CountrySelect2']; // Remove unnecessary field
                                this.app.callEvent('filter', [filterdata]); // Trigger filter event
                            },
                        },
                    ],
                },
            ],
        };

        // Configuration for additional buttons
        const buttons2 = {
            rows: [
                {
                    padding: 10,
                    cols: [
                        {
                            view: 'button', // Button to load CSV
                            value: _('Cargar CSV'),
                            type: 'form',
                            click: () => {
                                webix
                                    .ajax()
                                    .headers({
                                        'Content-type': 'application/json',
                                    })
                                    .post(devConfig.geturlApi() + 'Select/GetRestrictTypes', '', {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message('Error! '); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var resp = JSON.parse(text); // Parse response
                                            var base64CSV = ''; // Variable to hold Base64 CSV
                                            webix
                                                .ui({
                                                    view: 'window', // Window for CSV upload
                                                    fullscreen: true,
                                                    head: {
                                                        view: 'toolbar',
                                                        cols: [
                                                            {
                                                                view: 'label',
                                                                label: _('Restricción Masiva'), // Window title
                                                            },
                                                            {
                                                                view: 'icon',
                                                                icon: 'wxi-close',
                                                                click: function () {
                                                                    this.getTopParentView().hide(); // Close window
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    position: 'center',
                                                    modal: true, // Modal window
                                                    body: {
                                                        view: 'form',
                                                        id: 'addform2', // Form ID
                                                        elements: [
                                                            {
                                                                margin: 10,
                                                                rows: [
                                                                    {
                                                                        view: 'richselect', // Rich select for Partner
                                                                        labelPosition: 'top',
                                                                        label: _('Partner'),
                                                                        name: 'Partner',
                                                                        options: profile.Partners, // Options from profile
                                                                        required: true, // Required field
                                                                        value: profile.PartnerSelected, // Default selected value
                                                                        readonly: true, // Read-only field
                                                                    },
                                                                    {
                                                                        view: 'richselect', // Rich select for Country
                                                                        labelPosition: 'top',
                                                                        label: _('País'),
                                                                        name: 'Country',
                                                                        value: !devConfig.getCountryReport()
                                                                            ? '0'
                                                                            : profile.Settings.ReportCountry, // Default selected value
                                                                        readonly: !devConfig.getCountryReport()
                                                                            ? false
                                                                            : true, // Conditional read-only
                                                                        options: {
                                                                            body: {
                                                                                template: function (obj) {
                                                                                    return (
                                                                                        "<i class='flags " +
                                                                                        obj.icon +
                                                                                        "'></i>" +
                                                                                        obj.value
                                                                                    ); // Template for displaying country flags
                                                                                },
                                                                                data: countries, // Country data
                                                                            },
                                                                        },
                                                                        required: true, // Required field
                                                                    },
                                                                    {
                                                                        view: 'combo', // Dropdown for Type
                                                                        labelPosition: 'top',
                                                                        label: _('Tipo'),
                                                                        required: true, // Required field
                                                                        name: 'Type',
                                                                        options: resp.Data, // Options from response
                                                                    },
                                                                    {
                                                                        view: 'uploader', // Uploader for CSV file
                                                                        id: 'uploader',
                                                                        value: _('Cargar archivo CSV'),
                                                                        on: {
                                                                            onBeforeFileAdd: function (upload) {
                                                                                // Event before file is added
                                                                                getBase64(upload.file).then((data) => {
                                                                                    base64CSV = data; // Store Base64 CSV
                                                                                });
                                                                                $$('uploader').define(
                                                                                    'label',
                                                                                    upload.name,
                                                                                ); // Update label
                                                                                $$('uploader').refresh(); // Refresh uploader
                                                                                var reader = new FileReader(); // FileReader instance
                                                                                reader.onload = function (event) {
                                                                                    var records =
                                                                                        event.target.result.split('\n'); // Split file into records
                                                                                    for (
                                                                                        var i = 0;
                                                                                        i < records.length;
                                                                                        i++
                                                                                    ) {
                                                                                        var record = {}; // Record object
                                                                                        records[i] =
                                                                                            records[i].split(';'); // Split record by semicolon
                                                                                        for (
                                                                                            var r = 0;
                                                                                            r < records[i].length;
                                                                                            r++
                                                                                        ) {
                                                                                            record['field' + (r + 1)] =
                                                                                                records[i][r]; // Map fields
                                                                                        }
                                                                                        records[i] = record; // Update record
                                                                                    }
                                                                                    $$('dt1').clearAll(); // Clear existing data
                                                                                    records = records.filter((item) => {
                                                                                        return item.field1 != ''; // Filter out empty records
                                                                                    });
                                                                                    $$('dt1').parse(records); // Parse new records into datatable
                                                                                    $$('dt1').show(); // Show datatable
                                                                                };
                                                                                reader.readAsText(upload.file); // Read file as text
                                                                                return false; // Prevent default behavior
                                                                            },
                                                                        },
                                                                    },
                                                                    {
                                                                        view: 'datatable', // Datatable for displaying uploaded records
                                                                        id: 'dt1',
                                                                        css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                                                                        hidden: true, // Initially hidden
                                                                        scrollY: true, // Enable vertical scrolling
                                                                        scrollX: true, // Enable horizontal scrolling
                                                                        height: 0, // Conditional height
                                                                        columns: [
                                                                            {
                                                                                id: 'field1',
                                                                                width: 220,
                                                                                header: _('Email'), // Column header
                                                                            },
                                                                            {
                                                                                id: 'field2',
                                                                                header: _('Tipo Documento'), // Column header
                                                                                options: [
                                                                                    {
                                                                                        id: '1',
                                                                                        value: _(
                                                                                            'Cédula de ciudadania',
                                                                                        ),
                                                                                    },
                                                                                    {
                                                                                        id: '2',
                                                                                        value: _('Pasaporte'),
                                                                                    },
                                                                                    {
                                                                                        id: '3',
                                                                                        value: _('Cédula extranjería'),
                                                                                    },
                                                                                ],
                                                                                width: 220,
                                                                            },
                                                                            {
                                                                                id: 'field3',
                                                                                width: 220,
                                                                                header: _('Documento'), // Column header
                                                                            },
                                                                            {
                                                                                id: 'field4',
                                                                                width: 220,
                                                                                header: _('Nombre'), // Column header
                                                                            },
                                                                            {
                                                                                id: 'field5',
                                                                                width: 220,
                                                                                header: _('Teléfono'), // Column header
                                                                            },
                                                                        ],
                                                                    },
                                                                ],
                                                            },
                                                            {
                                                                cols: [
                                                                    {
                                                                        view: 'button', // Button to cancel the operation
                                                                        value: _('Cancelar'),
                                                                        click: function () {
                                                                            this.getTopParentView().hide(); // Close window
                                                                            $$('addform2').setValues(
                                                                                $$('addform2').getCleanValues(),
                                                                            ); // Reset form values
                                                                            $$('uploader').define(
                                                                                'label',
                                                                                _('Cargar archivo CSV'),
                                                                            ); // Reset uploader label
                                                                            $$('uploader').refresh(); // Refresh uploader
                                                                            base64CSV = ''; // Clear Base64 CSV
                                                                        },
                                                                    },
                                                                    {
                                                                        view: 'button', // Button to save the data
                                                                        type: 'form',
                                                                        value: _('Guardar'),
                                                                        click: function ($e) {
                                                                            var values = $$('addform2').getValues(); // Get form values
                                                                            if (
                                                                                $$('addform2').validate() &&
                                                                                base64CSV != ''
                                                                            ) {
                                                                                // Validate form and check if CSV is loaded
                                                                                webix
                                                                                    .ajax()
                                                                                    .headers({
                                                                                        'Content-type':
                                                                                            'application/json',
                                                                                    })
                                                                                    .post(
                                                                                        devConfig.geturlApi() +
                                                                                            'AdminUser/RestrictUser',
                                                                                        '{"CSV":"' +
                                                                                            base64CSV +
                                                                                            '", "Type":"' +
                                                                                            values.Type +
                                                                                            '", "Partner":"' +
                                                                                            values.Partner +
                                                                                            '", "Country":"' +
                                                                                            values.Country +
                                                                                            '", "Action":"1"}',
                                                                                        {
                                                                                            error: function (
                                                                                                text,
                                                                                                data,
                                                                                                XmlHttpRequest,
                                                                                            ) {
                                                                                                webix.message(
                                                                                                    'Error! ',
                                                                                                ); // Error message
                                                                                            },
                                                                                            success: function (
                                                                                                text,
                                                                                                data,
                                                                                                XmlHttpRequest,
                                                                                            ) {
                                                                                                text = JSON.parse(text); // Parse response
                                                                                                if (text.HasError) {
                                                                                                    webix.message(
                                                                                                        'Error: ' +
                                                                                                            text.AlertMessage,
                                                                                                    ); // Show error message
                                                                                                } else {
                                                                                                    webix.message(
                                                                                                        _(
                                                                                                            'Restricciónes creadas correctamente',
                                                                                                        ),
                                                                                                    ); // Success message
                                                                                                }
                                                                                            },
                                                                                        },
                                                                                    );
                                                                                this.getTopParentView().hide(); // Close window
                                                                            } else {
                                                                                webix.message({
                                                                                    title: _('¡Error!'),
                                                                                    type: 'alert-error',
                                                                                    text: _('Completa los campos...'), // Error message
                                                                                });
                                                                            }
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        ],
                                                        elementsConfig: {
                                                            on: {
                                                                onChange: function () {
                                                                    this.validate(); // Validate form on change
                                                                },
                                                            },
                                                        },
                                                    },
                                                })
                                                .show(); // Show the window
                                            $$('addform2').clearValidation(); // Clear validation
                                            $$('Type').define('options', resp.Data); // Update options for Type
                                            $$('Type').refresh(); // Refresh dropdown
                                        },
                                    });
                            },
                        },
                    ],
                },
                {
                    padding: 10,
                    cols: [
                        {
                            view: 'button', // Button to create restriction
                            value: _('Crear Restricción'),
                            type: 'form',
                            click: () => {
                                this.app.callEvent('create:button', [[]]); // Trigger create event
                            },
                        },
                    ],
                },
                {
                    padding: 10,
                    cols: [
                        {
                            view: 'button', // Button to clear form
                            value: _('Limpiar'),
                            click: () => {
                                $$('myForm2').setValues($$('myForm2').getCleanValues()); // Reset form values
                            },
                        },
                        {
                            view: 'button', // Button to consult/filter data
                            value: _('Consultar'),
                            hotkey: 'enter', // Enter key shortcut
                            type: 'form',
                            click: () => {
                                const filterdata = $$('myForm2').getValues(); // Get filter values
                                if (devConfig.getCountryReport()) {
                                    filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country filter if applicable
                                }
                                delete filterdata['CountrySelect2']; // Remove unnecessary field
                                this.app.callEvent('filter', [filterdata]); // Trigger filter event
                                $$('filterPopup').hide(); // Close filter popup
                            },
                        },
                    ],
                },
            ],
        };

        // Configuration for accordion section
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop', // CSS class for styling
                    collapsed: true, // Initially collapsed
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Accordion header
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        // Configuration for scrollable section
        const accordion_section3 = {
            view: 'scrollview',
            scroll: 'xy', // Enable both horizontal and vertical scrolling
            body: {
                padding: 10,
                rows: [upper_section], // Upper section
            },
        };

        // Configuration for filter popup window
        const filterPopup = webix.ui({
            view: 'window',
            move: true, // Allow window to be moved
            id: 'filterPopup', // Window ID
            fullscreen: true, // Fullscreen mode
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Window title
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close window
                        },
                    },
                ],
            },
            modal: true, // Modal window
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2', // Form ID
                type: 'clean',
                rows: [accordion_section3, buttons2], // Scrollable section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });

        // Return the main form configuration
        return {
            view: 'form',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section // Show accordion section on larger screens
                    : { height: 1, width: 0 }, // Placeholder for smaller screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }
}

// FILE DOCUMENTED
